import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=6ac65424&scoped=true"
import script from "./GroupList.vue?vue&type=script&lang=ts"
export * from "./GroupList.vue?vue&type=script&lang=ts"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=6ac65424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac65424",
  null
  
)

export default component.exports